<h1 translate
    matDialogTitle>
    log_details_modal_title
</h1>

<mat-dialog-content>
    <ui-json-formatter [data]="rawMessage"
                       [levelsOpen]="1"
                       [key]="'log_details_modal_raw_message' | translate"
                       [objectPlaceholder]="'global_json_object_placeholder' | translate"
                       [emptyPlaceholder]="'global_json_empty_placeholder' | translate">
    </ui-json-formatter>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-dialog-close
            mat-button
            type="button">
        {{ 'modal_action_close' | translate }}
    </button>
</mat-dialog-actions>
